import { useContext, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import MGMDashboardData from '../../../../services/user/mgm-dashboard-data'
import { UserDataContext, UserTypes } from '../../../../services/user/user-data'
import {
  PageConfig,
  MuleSoftConfigType,
  CbxConfigType
} from '../../../../utils/page-config'
import { GIGYA_COOKIE_JWT, GIGYA_COOKIE_UID } from '../../../../utils/constants'
import { isFeatureEnabled } from '../../../../utils/feature-toggle/feature-toggle'
import { FEATURE_TOGGLES } from '../../../../utils/feature-toggle/constants'
import { fetchMgmDashboardFromCBX } from '../../../../services/user/cbx-consumer-api'

export interface ReferralProps {
  referralDate: string
}

export interface RewardProps extends ReferralProps {
  type: string
  value: string
  loyaltyPoints: number
  couponCode: string
  burnedDate: string
  expirationDate: string
}

export const useDashboardData = () => {
  const [data, setData] = useState<{
    mgmReferralCode: string
    referrals: Array<ReferralProps>
    maxGodsonsReferral: number
    rewards: Array<RewardProps>
  } | null>(null)
  const [cookies] = useCookies([GIGYA_COOKIE_UID, GIGYA_COOKIE_JWT])
  const userData = useContext(UserDataContext)
  const configMuleSoft = PageConfig?.getConfig(
    PageConfig?.ConfigObjects?.MuleSoftConfig
  ) as MuleSoftConfigType | null | undefined

  const caConfig = PageConfig?.getConfig() as
    | {
        lang?: string
      }
    | null
    | undefined

  const cbxConfig = PageConfig?.getConfig(
    PageConfig?.ConfigObjects?.CbxConfig
  ) as CbxConfigType | null | undefined

  // Extended MuleSoft config type to include optional platform and baseSiteId
  type ExtendedMuleSoftConfig = MuleSoftConfigType & {
    platform?: string
    baseSiteId?: string
  }

  useEffect(() => {
    const isMock = false
    const fetchDashboardData = async () => {
      const extendedConfig = configMuleSoft as
        ExtendedMuleSoftConfig | null | undefined

      if (
        isFeatureEnabled(FEATURE_TOGGLES.CBX_CONSUMER_MGM) &&
        cbxConfig?.cbxUrl
      ) {
        const cbxData = await fetchMgmDashboardFromCBX({
          consumerId: cookies?.gig_uid ? atob(cookies.gig_uid) : 'anonymous',
          token: cookies?.gig_jwt || '',
          cbxConfig,
          platform: extendedConfig?.platform || '',
          baseSiteId: extendedConfig?.baseSiteId || ''
        })
        if (cbxData) {
          setData(cbxData)
          return
        }
      }

      const dashboardData = await MGMDashboardData.getMGMDashboardData(
        configMuleSoft?.url || '',
        cookies?.gig_uid ? atob(cookies.gig_uid) : 'anonymous',
        configMuleSoft?.xChannel || '',
        cookies?.gig_jwt || '',
        extendedConfig?.platform || '',
        extendedConfig?.baseSiteId || '',
        caConfig?.lang || '',
        isMock
      )
      setData(dashboardData)
    }

    if (userData?.decoratedUserType !== UserTypes.Las || isMock) {
      fetchDashboardData()
    }
  }, [])

  return data
}
